import { TermScheduleFlags } from '../../services/term_schedule_flags';
import { RegistrationWaitlistPositionModel } from '../../models/registration_waitlist_position_model';
import { ICommand } from 'core-ts-types';
import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import { ISection } from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant, IFormattedSectionTime } from '../../../sections/servants/section_info_servant';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { ScheduledSectionTileServant } from '../../servants/scheduled_section_tile_servant';
import { ScheduledSectionStatus } from '../../types/scheduled_section_status_enum';
import * as _4 from 'lodash4';
import { SchedulerModel } from '../../models/scheduler_model';
import { CommunicatorService } from 'ui-ng-component-communicator';

class ScheduledSectionWaitlistMessage {
  private section: ISection;
  private showJoinWaitlistOption: boolean;
  private canBeRegistered: boolean;
  private isStatusPending: boolean;
  private isWaitlistEnabled: boolean;
  private isBatchRegisterWaitlistedStudentsEnabled: boolean;
  private waitlistPositionText: string;
  private canAddFromWaitlist: boolean;
  private placeInWaitlist: number;
  private waitlistPositionProps: any;
  private isWaitlisted: boolean;
  private isAutoWaitlistedHidePos: boolean;
  private hasSeatsAvailable: boolean;
  private showWaitlistSeatAvailableMessage: boolean = false;
  private openWaitListPrompt: boolean = false;
  private serverWaitlistAvailableText: string = '';
  constructor(
    private ngScheduledSectionTileServant: ScheduledSectionTileServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private waitlistSectionCommand: ICommand,
    private getTermPinCommand: ICommand,
    private $stateParams: ng.ui.IStateParamsService,
    private $state: ng.ui.IStateService,
    private ngRegistrationWaitlistPositionModel: RegistrationWaitlistPositionModel,
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngSchedulerModel: SchedulerModel,
    private updateSeatAvailabilityCommand: ICommand,
    private getSectionDetailsCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}
  initialize() {
    this.isWaitlistEnabled = this.ngTermScheduleFlags.isWaitlistEnabled();
    this.isBatchRegisterWaitlistedStudentsEnabled = this.ngTermScheduleFlags.isBatchRegisterWaitlistedStudentsEnabled();
    const isSectionWaitlisted = this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section);
    const isSectionScheduled = this.ngScheduledSectionStatusServant.isSectionScheduled(this.section);
    this.canBeRegistered = this.ngScheduledSectionServant.canBeRegistered(this.section);
    this.canAddFromWaitlist = this.ngScheduledSectionServant.canAddFromWaitlist(this.section);
    this.isStatusPending = this.ngScheduledSectionStatusServant.isStatusPending(this.section);
    this.waitlistPositionProps = this.ngRegistrationWaitlistPositionModel.get(this.section.id);
    this.placeInWaitlist = _4.get(this.waitlistPositionProps, 'place_in_waitlist', 0);
    this.isWaitlisted = this.isWaitlistEnabled && isSectionWaitlisted;
    this.isAutoWaitlistedHidePos = this.ngScheduledSectionServant.isAutoWaitlistedHidePosition(this.section);
    this.serverWaitlistAvailableText = _4.get(
      this.ngSchedulerModel.read(),
      'customtext.WAITLIST_SEAT_AVAILABLE.text',
      ''
    );
    // is_seat_available property take care of waitlist queues. So dont rely on available seats.
    this.showJoinWaitlistOption =
      !this.isStatusPending &&
      isSectionScheduled &&
      this.isWaitlistEnabled &&
      !this.ngScheduledSectionServant.isSeatAvailable(this.section) &&
      this.canBeRegistered;

    this.waitlistPositionText = this.getWaitlistText(this.section);
    this.hasSeatsAvailable = ScheduledSectionServant.hasAvailableSeats(this.section);
    this.showWaitlistSeatAvailableMessage =
      !_4.isEmpty(this.serverWaitlistAvailableText) &&
      !this.isBatchRegisterWaitlistedStudentsEnabled &&
      this.canAddFromWaitlist &&
      !this.isStatusPending &&
      !this.isAutoWaitlistedHidePos &&
      this.hasSeatsAvailable;
  }
  $onInit() {
    this.initialize();
  }

  $onChanges(changes: { section: ISection }) {
    this.initialize();
  }
  addToWaitlist() {
    this.getTermPinCommand(this.$stateParams.termId).then(() => {
      this.getSectionDetailsCommand(this.section.id).then(() => {
        this.ngComponentCommunicatorService.publish('OPEN_WAITLIST_PROMPT');
      });
    });
  }
  private getWaitlistText(section: ISection) {
    const hasSeatsAvailable = ScheduledSectionServant.hasAvailableSeats(section); // section._section_status.avail_seats === 0
    // calculated 'place_in_waitlist' when server doesn't know all students on waitlist
    if (!this.waitlistPositionProps) {
      return ``;
    }
    if (_4.isNull(this.placeInWaitlist) || this.placeInWaitlist === 0) {
      return `Added To Waitlist`;
    } else {
      const positionInWaitlist = this.waitlistPositionProps
        ? this.placeInWaitlist - 1 - _4.get(section, '_availability.avail_seats', -1)
        : -1;
      const text = positionInWaitlist > 0 ? ' Students ahead of you' : ' Student ahead of you';
      if (positionInWaitlist < 0) {
        return 'Seat Available';
      } else if (positionInWaitlist === 0 && !hasSeatsAvailable) {
        return 'Next in line, but there are no seats open yet!';
      } else {
        return positionInWaitlist + text;
      }
    }
  }
}

class ScheduledSectionWaitlistMessageComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = ScheduledSectionWaitlistMessage;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_waitlist_message/scheduled_section_waitlist_message.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('scheduledSectionWaitlistMessage', new ScheduledSectionWaitlistMessageComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_waitlist_message/scheduled_section_waitlist_message.ts